import { formatUSD } from '../../../utils/methods';
import { formatTimeLocal } from '../../../utils/time';
import { MarginRequirements } from './MarginRequirementsGrid';

const columnDefs = [
  {
    headerName: 'Time',
    filter: 'agMultiColumnFilter',
    initialWidth: 150,
    valueGetter: ({ data }: { data?: MarginRequirements }) =>
      formatTimeLocal(data?.time),
  },
  {
    headerName: 'Trade Date',
    filter: 'agMultiColumnFilter',
    initialWidth: 150,
    valueGetter: ({ data }: { data?: MarginRequirements }) =>
      formatTimeLocal(data?.tradeDate),
  },
  {
    field: 'type',
    headerName: 'Type',
    filter: 'agMultiColumnFilter',
    initialWidth: 150,
  },
  {
    field: 'firmCode',
    headerName: 'Firm',
    filter: 'agMultiColumnFilter',
    initialWidth: 150,
  },
  {
    field: 'accountCode',
    headerName: 'Account',
    filter: 'agMultiColumnFilter',
    initialWidth: 150,
  },
  {
    headerName: 'Account Type',
    field: 'accountType',
    filter: 'agMultiColumnFilter',
    initialWidth: 150,
  },
  {
    headerName: 'Origin',
    field: 'origin',
    filter: 'agMultiColumnFilter',
    initialWidth: 150,
  },
  {
    headerName: 'Applied Requirement',
    filter: 'agMultiColumnFilter',
    initialWidth: 200,
    valueGetter: ({ data }: { data?: MarginRequirements }) =>
      formatUSD(data?.marginRequirement),
  },
  {
    headerName: 'Comment',
    field: 'overrideComment',
    filter: 'agMultiColumnFilter',
    initialWidth: 150,
  },
  {
    headerName: 'Span Margin',
    filter: 'agMultiColumnFilter',
    initialWidth: 150,
    valueGetter: ({ data }: { data?: MarginRequirements }) =>
      formatUSD(data?.spanMarginRequirement),
  },
  {
    headerName: 'Span Margin Override',
    filter: 'agMultiColumnFilter',
    initialWidth: 200,
    valueGetter: ({ data }: { data?: MarginRequirements }) =>
      formatUSD(data?.spanMarginRequirementOverride),
  },
  {
    headerName: 'Guaranty Fund',
    filter: 'agMultiColumnFilter',
    initialWidth: 150,
    valueGetter: ({ data }: { data?: MarginRequirements }) =>
      formatUSD(data?.guarantyFund),
  },
  {
    headerName: 'Guaranty Fund Override',
    filter: 'agMultiColumnFilter',
    initialWidth: 200,
    valueGetter: ({ data }: { data?: MarginRequirements }) =>
      formatUSD(data?.guarantyFundOverride),
  },
  {
    headerName: 'Concentration Add On',
    filter: 'agMultiColumnFilter',
    initialWidth: 200,
    valueGetter: ({ data }: { data?: MarginRequirements }) =>
      formatUSD(data?.concentrationAddOn),
  },
  {
    headerName: 'Concentration Add On Override',
    filter: 'agMultiColumnFilter',
    initialWidth: 200,
    valueGetter: ({ data }: { data?: MarginRequirements }) =>
      formatUSD(data?.concentrationAddOnOverride),
  },
  {
    headerName: 'Stress Add On',
    filter: 'agMultiColumnFilter',
    initialWidth: 150,
    valueGetter: ({ data }: { data?: MarginRequirements }) =>
      formatUSD(data?.stressAddOn),
  },
  {
    headerName: 'Stress Add On Override',
    filter: 'agMultiColumnFilter',
    initialWidth: 200,
    valueGetter: ({ data }: { data?: MarginRequirements }) =>
      formatUSD(data?.stressAddOnOverride),
  },
  {
    headerName: 'Cover 2 Add On',
    filter: 'agMultiColumnFilter',
    initialWidth: 150,
    valueGetter: ({ data }: { data?: MarginRequirements }) =>
      formatUSD(data?.cover_2AddOn),
  },
  {
    headerName: 'Cover 2 Add On Override',
    filter: 'agMultiColumnFilter',
    initialWidth: 250,
    valueGetter: ({ data }: { data?: MarginRequirements }) =>
      formatUSD(data?.cover_2AddOnOverride),
  },
  {
    headerName: 'Discretionary Add On',
    filter: 'agMultiColumnFilter',
    initialWidth: 200,
    valueGetter: ({ data }: { data?: MarginRequirements }) =>
      formatUSD(data?.discretionaryAddOn),
  },
  {
    headerName: 'Discretionary Add On Override',
    filter: 'agMultiColumnFilter',
    initialWidth: 250,
    valueGetter: ({ data }: { data?: MarginRequirements }) =>
      formatUSD(data?.discretionaryAddOnOverride),
  },
];

export default columnDefs;
